import React, { useRef, useState } from 'react'
import { useClickAway, useMedia } from 'react-use'
import styled from 'styled-components'
import { ScreenDefault } from '.'

const Wrapper = styled.aside<{ $isMobile: boolean; $isOpen: boolean }>`
  position: ${({ $isMobile }) => ($isMobile ? 'relative' : 'absolute')};
  margin-top: ${({ $isMobile }) => ($isMobile ? '0' : '90px')};
  ${({ $isMobile }) => ($isMobile ? 'left: 0;' : '')}
  ${({ $isMobile }) => ($isMobile ? 'bottom: 0;' : 'top: 0;')}

  .layer {
    width: ${({ $isMobile }) => ($isMobile ? '80vw' : '20vw')};
    background-color: white;
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadow(1)};

    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background-color: ${({ theme }) => theme.backdropBackground};
      -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
      backdrop-filter: ${({ theme }) => theme.backdropFilter};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      position: absolute;
      bottom: 0;
      left: calc(40px + ${({ theme }) => theme.padding(0.3)});
      max-width: 300px;
      overflow: hidden;
      opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
      visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
      transform: translateY(${({ $isOpen }) => ($isOpen ? '0' : '30%')});
      transition:
        opacity 0.3s ease-in-out,
        transform 0.3s ease-in-out,
        visibility 0.3s ease-in-out;
    }
  }
`

interface BaseListProps {
  children: React.ReactNode
}

export const BaseList = ({ children }: BaseListProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)
  const isMobile = useMedia('(max-width: 768px)')

  useClickAway(ref, () => {
    if (isMobile && isOpen) {
      setIsOpen(false)
    }
  })

  return (
    <Wrapper ref={ref} $isOpen={isOpen} $isMobile={isMobile}>
      {isMobile ? (
        <ScreenDefault.Button isOpen={isOpen} onClick={() => setIsOpen(current => !current)} />
      ) : null}
      <main className='layer'>{children}</main>
    </Wrapper>
  )
}
